import React from 'react';
// import './RangeSlider.css';

const RangeSlider = (props) => {
    const handleInputChange = (evt) => {
        const value = evt.target.value;
        props.onChange(value);
    }

    return (
        <div className='section-container' >
            <label 
                htmlFor={props.title}
                className="flexed-section-v1"
            >
                <span className="title">{props.description}</span>
                <span className="unit">{props.symbol}{props.value} {props.unit}</span>
            </label>
            <input
                id={props.title}
                type='range'
                min={props.min}
                max={props.max}
                step={props.step}
                value={props.value}
                onChange={handleInputChange}
            />
            <div className="flexed-section-v1 min-max-range">
                <span>{props.symbol}{props.min}</span>
                <span>{props.symbol}{props.max}</span>
            </div>
            <output className='hidden'>{props.symbol}{props.value} {props.unit}</output>
            {props.helpTxt ? (
                <div className='helper-text'>
                    <p>{props.helpTxt}</p>
                </div>
                ) : ''}
            { props.children }
        </div>
    );
}

export default RangeSlider;